import { render, staticRenderFns } from "./CambioContrasena.vue?vue&type=template&id=501e075d&scoped=true&"
import script from "./CambioContrasena.vue?vue&type=script&lang=js&"
export * from "./CambioContrasena.vue?vue&type=script&lang=js&"
import style0 from "./CambioContrasena.vue?vue&type=style&index=0&id=501e075d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501e075d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VFooter,VTextField})
